import Accordion from '@mui/material/Accordion';
import { styled } from '@mui/material/styles';
const CustomAccordion = styled(Accordion)(() => ({
    "&::before": {
        display: 'none'
    }
}));
export default CustomAccordion;
